export default "__VITE_ASSET__BvMJb5Of__"